import script from "./SuggestedPriceEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuggestedPriceEditor.vue?vue&type=script&setup=true&lang=ts"

import "./SuggestedPriceEditor.vue?vue&type=style&index=0&id=32403216&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2158973318/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32403216"]])

export default __exports__